
import { Watch, Mixins, Component, ProvideReactive, Ref } from "vue-property-decorator";
import TwoHourList from "./components/TwoHourList.vue";
import WeightManagement from "./components/WeightManagement.vue";


@Component({ name: 'two-hour-index',
  inject: [],
  components: { TwoHourList, WeightManagement }
})
export default class TwoHourIndex extends Mixins() {
    @ProvideReactive() currentTab = "1";
    @Ref("twoHourList") twoHourListRef!: TwoHourList;
    @Ref("weightManagement") weightManagementRef!: WeightManagement;

    handleTabClick() {
      // Tab切换时，v-if会自动触发子组件的mounted，无需手动调用
    }
}

